/**
 * Local-hour greeting period for Dashboard welcome.
 * Bom dia 05–11 · Boa tarde 12–17 · Boa noite 18–04.
 */
export const resolveTimeOfDayGreetingPeriod = (date = new Date()) => {
  const hour = date instanceof Date ? date.getHours() : new Date().getHours();
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 18) return "afternoon";
  return "evening";
};

/** intl key under `dashboard.*` for the period greeting with `{name}`. */
export const resolveDashboardGreetingKey = (date = new Date()) => {
  const period = resolveTimeOfDayGreetingPeriod(date);
  if (period === "morning") return "dashboard.greetingMorning";
  if (period === "afternoon") return "dashboard.greetingAfternoon";
  return "dashboard.greetingEvening";
};

/** Legal / corporate suffixes kept uppercase in greeting display names. */
const GREETING_NAME_ACRONYMS = new Set([
  "LLC",
  "LTDA",
  "SA",
  "S.A",
  "S.A.",
  "ME",
  "EIRELI",
  "EPP",
  "SS",
  "INC",
  "LP",
  "LLP",
  "PLC",
  "GMBH",
  "BV",
  "NV",
]);

const titleCaseWordPart = (part) => {
  const trimmed = String(part || "");
  if (!trimmed) return trimmed;
  const upper = trimmed.toUpperCase();
  if (GREETING_NAME_ACRONYMS.has(upper)) return upper;
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
};

/**
 * Title-case entity / person name for Dashboard greeting.
 * Preserves common legal acronyms (LLC, LTDA, S.A., …).
 */
export const formatGreetingDisplayName = (name) => {
  const raw = String(name || "").trim();
  if (!raw) return "";

  return raw.replace(/[^\s,]+/g, (token) => {
    const match = token.match(/^([A-Za-zÀ-ÿ.]+)(.*)$/u);
    if (!match) return token;
    const [, word, suffix] = match;
    const upperWord = word.toUpperCase();
    if (GREETING_NAME_ACRONYMS.has(upperWord)) {
      return upperWord + suffix;
    }
    if (word.includes("-")) {
      return word.split("-").map(titleCaseWordPart).join("-") + suffix;
    }
    return titleCaseWordPart(word) + suffix;
  });
};
